/**
 * @generated SignedSource<<59bdf6903d6eebf2e54af64858adbdfe>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum ReverseTrialCohort {
  CONTROL = "CONTROL",
  ENROLLED = "ENROLLED",
  NOT_ENROLLED = "NOT_ENROLLED",
  UNASSIGNED = "UNASSIGNED",
  UNKNOWN = "UNKNOWN",
  VARIANT = "VARIANT",
}
export type useReverseTrialEligibleSignUpPropertiesQuery_signUpProperties_SignUpProperties =
  {
    __typename?: "SignUpProperties";
    reverseTrial: ReverseTrialCohort | null;
  };
export type useReverseTrialEligibleSignUpPropertiesQuery_Query = {
  __typename?: "Query";
  signUpProperties: useReverseTrialEligibleSignUpPropertiesQuery_signUpProperties_SignUpProperties | null;
};
export type useReverseTrialEligibleSignUpPropertiesQueryVariables = Exact<{
  [key: string]: never;
}>;
export type useReverseTrialEligibleSignUpPropertiesQuery =
  useReverseTrialEligibleSignUpPropertiesQuery_Query;
